module.exports = __webpack_public_path__ + "img/men.120babb1.svg";